module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SD - Sudan.5eb573c2.svg";